export class PageableDto<T> {
  result: T[];
  total: number;
}
